type WorkBreakable = { minutes: number; trackedMinutes: number }

export function getTotalMinutes<T extends WorkBreakable>(workedBreaks: T[]) {
  return workedBreaks.reduce((total, workedBreak) => total + workedBreak.trackedMinutes, 0)
}
